import * as MODAL_ACTIONS from './types'

export const setModal = (payload) => ({
  type: MODAL_ACTIONS.SET_MODAL,
  payload,
})

export const closeModal = () => ({
  type: MODAL_ACTIONS.CLOSE_MODAL,
})

export const closeOverlays = () => ({
  type: MODAL_ACTIONS.CLOSE_OVERLAYS,
})
